export default __webpack_public_path__ + "static/media/RecebaImformacoes.98f75faa.png";